import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW2500Component } from './kymw2500.component';
import { DeletePageCopyLineService } from './api-services/delete-page-copy-line.service';
import { GetPageCopyService } from './api-services/get-page-copy.service';
import { GetPagenationDetailService } from './api-services/get-pagenation-detail.service';
import { OutputPagenationListService } from './api-services/output-pagenation-list.service';
import { RegistPageCopyService } from './api-services/regist-page-copy.service';

/**
 * ページネーション設定画面 モジュール設定クラス
 *
 * @export SampleWindowModule
 * @class SampleWindowModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW2500Component,
  ],
  providers: [
    DeletePageCopyLineService,
    GetPageCopyService,
    GetPagenationDetailService,
    OutputPagenationListService,
    RegistPageCopyService,
  ],
})
export class KYMW2500Module { }
